import React from 'react'
import PropTypes from 'prop-types'

// Components
import {Button, routeTypes} from '@/components/ui/button'

// Constants
import {quizStatuses} from './lcModuleConstants'

// Other
import {ctaTypes} from './lcModuleConstants'
import {useAppOrigin} from '~/app/hooks/use-app-origin'

const getCtaText = (ctaType) => {
    if (ctaType === ctaTypes.NEXT_GOAL) {
        return 'Find My Next Goal'
    } else if (ctaType === ctaTypes.RETURN_TO_GOAL) {
        return 'Return to Goal'
    } else {
        return 'Next Module'
    }
}

const CtaSection = ({
    quizStatus,
    setQuizStatus,
    requestInProgress,
    goToNextModule,
    nextModuleData,
    ctaType,
    isLevelComplete
}) => {
    const appOrigin = useAppOrigin()
    let contentToRender = ''

    switch (quizStatus) {
        case quizStatuses.FAILED:
            contentToRender = (
                <Button
                    ctaType="button"
                    variant="primary"
                    className="w-full lg:w-[12.25rem]"
                    onClick={() => setQuizStatus(quizStatuses.OPEN)}
                    data-testid="ctaSection-Button"
                >
                    Redo Quiz
                </Button>
            )
            break
        case quizStatuses.PASSED:
            contentToRender = (
                <>
                    {isLevelComplete && (
                        <Button
                            ctaType="button"
                            variant="secondary"
                            className="w-full lg:w-[12.25rem]"
                            routeType={routeTypes.SFRA}
                            hrefValue={`${appOrigin}/loyalty-perks`}
                            asChild
                            data-testid="ctaSection-Button"
                        >
                            See My Points
                        </Button>
                    )}
                    <Button
                        ctaType="button"
                        variant="primary"
                        className="w-full lg:w-[12.25rem] mt-4 lg:mt-0 lg:ml-4"
                        onClick={(e) => {
                            e.preventDefault()
                            goToNextModule(nextModuleData)
                        }}
                        disabled={requestInProgress}
                        data-testid="ctaSection-Button"
                    >
                        {getCtaText(ctaType)}
                    </Button>
                </>
            )
            break

        default:
            break
    }

    return (
        <div className="flex flex-col mt-[3.25rem] lg:flex-row lg:justify-end">
            {contentToRender}
        </div>
    )
}

CtaSection.propTypes = {
    quizStatus: PropTypes.string.isRequired,
    setQuizStatus: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool.isRequired,
    goToNextModule: PropTypes.func.isRequired,
    nextModuleData: PropTypes.object.isRequired,
    ctaType: PropTypes.string.isRequired,
    isLevelComplete: PropTypes.bool.isRequired
}

export default CtaSection
